/**
 * The word each guest-journey log line ends with, so one Bugfender search returns one kind of event. Invented
 * single words: the search matches whole words in any order, and a plain word ("live", "pay") would also match
 * unrelated lines.
 */
export enum LogFilterWord {
	TicketOpened = 'gpanchor',
	LiveStatus = 'gplive',
	LiveTrackingLost = 'gplost',
	PaymentResult = 'gppay',
	PaymentRefresh = 'gprefresh',
	CallbackNavigation = 'gpnav',
	Recaptcha = 'gpcaptcha',
	AmountsTable = 'gptable',
}
